import { render, staticRenderFns } from "./dates-title.vue?vue&type=template&id=07038dd2&scoped=true"
import script from "./dates-title.vue?vue&type=script&lang=js"
export * from "./dates-title.vue?vue&type=script&lang=js"
import style0 from "./dates-title.vue?vue&type=style&index=0&id=07038dd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07038dd2",
  null
  
)

export default component.exports